module.exports = require("body-parser");


//////////////////
// WEBPACK FOOTER
// external "body-parser"
// module id = 20
// module chunks = 0